export default __webpack_public_path__ + "static/media/venta-pagado.46f7a6ad.svg";